import dayjs from "dayjs";

export const LoadboardDate = ({ date }) => {
    return date ? dayjs(date).format("MMM DD, YYYY") : "-";
};
